import React from "react";
import { Container, Row, Col } from "reactstrap";

import { getMessage } from "CONFIG/i18n";

const ServerUnreachable = (props) => {
  return (
    <>
      <section className="bgColor">
        <Container>
          <Row>
            <Col md="12" lg="12">
              <h4 className="text-center pt-5">{getMessage("SERVER_UNREACHABLE_ERROR")}</h4>
              <h4 className="text-center">{getMessage("NETWORK_ERROR")}</h4>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default ServerUnreachable;